import React from "react";
// import '../../assets/js/layout.js';
//import { useNavigate } from "react-router-dom";
// import '../../assets/libs/bootstrap/js/bootstrap.bundle.min.js';
// import { AuthData } from "../../auth/AuthWrapper";
import {PRODUCT_NAME} from "../../utils/config_mapping"
export const RenderHeader = () => {
    // const { isLoggedIn, logout } = AuthData();
    // const [isFullscreen, setIsFullscreen] = useState(false); // State to track fullscreen status
  //  const navigate = useNavigate();
    // const logout = () => {
    //     localStorage.setItem("login",0)
    //     navigate("/logout")
    //     window.location.reload(); // Force a full page reload to apply changes
    // }
    // const fullscreen = () =>{
    //     const element = document.documentElement; // Fullscreen for the whole page
    //     if (!document.fullscreenElement &&    // Standard API
    //         !document.webkitFullscreenElement && // Safari/Old WebKit
    //         !document.mozFullScreenElement &&   // Old Firefox
    //         !document.msFullscreenElement) {   // Old IE/Edge
    //         // Enter fullscreen
    //         if (element.requestFullscreen) {
    //             element.requestFullscreen();
    //         } else if (element.webkitRequestFullscreen) { // Safari/Old WebKit
    //             element.webkitRequestFullscreen();
    //         } else if (element.mozRequestFullScreen) { // Old Firefox
    //             element.mozRequestFullScreen();
    //         } else if (element.msRequestFullscreen) { // Old IE/Edge
    //             element.msRequestFullscreen();
    //         }
    //         setIsFullscreen(true);
    //     } else {
    //         // Exit fullscreen
    //         if (document.exitFullscreen) {
    //             document.exitFullscreen();
    //         } else if (document.webkitExitFullscreen) { // Safari/Old WebKit
    //             document.webkitExitFullscreen();
    //         } else if (document.mozCancelFullScreen) { // Old Firefox
    //             document.mozCancelFullScreen();
    //         } else if (document.msExitFullscreen) { // Old IE/Edge
    //             document.msExitFullscreen();
    //         }
    //         setIsFullscreen(false); // Update state to not fullscreen
    //     }
    // }
    // const themeChange = () => {
    //     const htmlElement = document.documentElement; // Refers to the <html> tag
    //     const currentTheme = htmlElement.getAttribute('data-bs-theme');
    //     // Toggle between 'light' and 'dark'
    //     const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    //     htmlElement.setAttribute('data-bs-theme', newTheme);
    //     htmlElement.setAttribute('data-bs-theme', newTheme);
    //     if (currentTheme) {
    //         document.body.classList.remove('dark-theme');
    //         document.body.classList.add('light-theme');
    //     } else {
    //         document.body.classList.remove('light-theme');
    //         document.body.classList.add('dark-theme');
    //     }
    // };
     return (
<header id="page-topbar" className="d-none">
    <div className="layout-width">
        {/* <div className="navbar-header">
            <div className="d-flex">
                <div className="navbar-brand-box horizontal-logo">
                    <a href="index.html" className="logo logo-dark">
                        <span className="logo-sm">
                        <h3 className="text-primary" style={{fontSize: "18px",marginBottom:"0px"}}><span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} /></h3>
                        </span>
                        <span className="logo-lg">
                        <h3 className="text-primary" style={{fontSize: "18px",marginBottom:"0px"}}><span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} /></h3>
                        </span>
                    </a>
                    
                </div>
                 </div>
    </div> */}
    </div>
</header>
     )
}